/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolElectricalServicesIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-electrical-services"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M19.98 15.32Q19.43 15.32 19.04 14.94Q18.65 14.55 18.65 14Q18.65 13.45 19.04 13.06Q19.43 12.68 19.98 12.68L20.98 12.68Q21.52 12.68 21.91 13.06Q22.3 13.45 22.3 14Q22.3 14.55 21.91 14.94Q21.52 15.32 20.98 15.32ZM19.98 19.32Q19.43 19.32 19.04 18.94Q18.65 18.55 18.65 18Q18.65 17.45 19.04 17.06Q19.43 16.68 19.98 16.68L20.98 16.68Q21.52 16.68 21.91 17.06Q22.3 17.45 22.3 18Q22.3 18.55 21.91 18.94Q21.52 19.32 20.98 19.32ZM14 20.32Q13.13 20.32 12.47 19.75Q11.82 19.18 11.7 18.32L11 18.32Q10.45 18.32 10.06 17.94Q9.68 17.55 9.68 17L9.68 15Q9.68 14.45 10.06 14.06Q10.45 13.68 11 13.68L11.7 13.68Q11.82 12.82 12.47 12.25Q13.13 11.68 14 11.68L16 11.68Q16.55 11.68 16.94 12.06Q17.32 12.45 17.32 13L17.32 19Q17.32 19.55 16.94 19.94Q16.55 20.32 16 20.32ZM6.03 17.32Q4.22 17.32 2.96 16.06Q1.7 14.8 1.7 13Q1.7 11.2 2.96 9.94Q4.22 8.68 6.03 8.68L7.53 8.68Q8.03 8.68 8.36 8.34Q8.7 8 8.7 7.5Q8.7 7 8.36 6.66Q8.03 6.33 7.53 6.33L4.03 6.33Q3.48 6.33 3.09 5.94Q2.7 5.55 2.7 5Q2.7 4.45 3.09 4.06Q3.48 3.67 4.03 3.67L7.53 3.67Q9.1 3.67 10.22 4.8Q11.35 5.92 11.35 7.5Q11.35 9.07 10.22 10.2Q9.1 11.32 7.53 11.32L6.03 11.32Q5.33 11.32 4.84 11.81Q4.35 12.3 4.35 13Q4.35 13.7 4.84 14.19Q5.33 14.68 6.03 14.68L7.03 14.68Q7.58 14.68 7.96 15.06Q8.35 15.45 8.35 16Q8.35 16.55 7.96 16.94Q7.58 17.32 7.03 17.32Z" fill={color} />
    </svg>
  );
}
